import { PATIENT } from '../model/type/clinic-role';
import { Role } from '../model/type/role.enum';

export function getAuthenticatedLandingPath(
  selectedRole: string | undefined,
  selectedClinicRole: string | undefined
): string {
  if (selectedRole === Role.Regular) {
    return selectedClinicRole === PATIENT ? '/results' : '/patients';
  }

  return '/users';
}
